export namespace QuickCheckoutConstants {
    export const SLIDE_IN_CONTAINER_ID = 'quickcheckout-slideins';
    export const BASE_PADDING = '28px';
    export const BORDER_RADIUS = '6px';
    export const INPUT_HEIGHT = '46px';
}
